// @flow

import { DraftLiveStateEnum } from "@modules/service/constants";
import type { ReferralState } from "./types";

export const initialState: ReferralState = {
  requestsInProgress: 0,
  schema: null,
  list: null,
  current: null,
  draft: null,
  assignments: [],
  configuration: {
    enabled: true,
    status: DraftLiveStateEnum.LIVE,
  },
  modals: {
    modalStep: 1,
    showAddModal: false,
    showEditModal: false,
    showEditAssignmentsModal: false,
    showDiscardModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
  },
};

export default initialState;
